import React from 'react'
import Modal from '../modals/ModalBoth'
import { Bono, BonoContent, ButtonClose, ModalTitle } from './BonosElements';
import CloseIcon from '@mui/icons-material/Close';
import { getEstadoBono } from '../../utils/tools';
import { useTranslation } from 'react-i18next';

const BonoModal = ({open, setOpen, bono, setBono}) => {

  const [t] = useTranslation('global');

  const handleClose = () => {
    setBono(null);
    setOpen(false);
  }
  return (
    <Modal open={open} handleClose={handleClose} maxWidth='sm' fullWidth={false} children={
      <Bono>
        <ModalTitle>
          <h2>{t('bonos.detalles')}</h2>
          <ButtonClose onClick={handleClose}>
            <CloseIcon/>
          </ButtonClose>
        </ModalTitle>
        <BonoContent>
            {bono.mensaje && <p>{bono.mensaje}</p>}
            <div className='between bg'>
              <div>{t('bonos.apostado')}: {bono.apostado}</div>
              <div>{t('bonos.restante')}: {bono.restante}</div>
            </div>
            <div className='body'>
              <h3>{bono.id} - {bono.nombre}</h3>
              <div className='between'>
                <div>
                  <span>{t('bonos.inicio')}</span>
                  <span className='span'>{bono.fecha_inicio}</span>
                </div>
                <div>
                  <span>{t('bonos.fin')}</span>
                  <span className='span'>{bono.fecha_vence}</span>
                </div>
                <div>
                  <span>{t('bonos.requisitos')}</span>
                  <span className='span'>{bono.rollover}</span>
                </div>
              </div>
            </div>
            <div className='bg estado'> <span className={getEstadoBono(bono.estado).clase}> {t(`bonos.${getEstadoBono(bono.estado).title}`)}</span></div>
        </BonoContent>
      </Bono>
    } />
  )
}

export default BonoModal